import { format } from 'date-fns';
import * as React from 'react';
export default {
  format,
  React
};